var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOperator = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 382.005 511"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 306",
  d: "M191.002 0c-83.26 0-151 67.74-151 151v233a15.005 15.005 0 0015 15h272a15.005 15.005 0 0015-15V151c0-83.26-67.74-151-151-151z",
  fill: "#08475e"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 307",
  d: "M342.002 151v233a15.005 15.005 0 01-15 15h-136V0c83.26 0 151 67.74 151 151z",
  fill: "#05303d"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 308",
  d: "M367.002 511h-352a15.008 15.008 0 01-14.93-16.48l10.6-83.97A74.761 74.761 0 0185.302 343h211.4a74.76 74.76 0 0174.63 67.54l10.6 83.979A15.008 15.008 0 01367.002 511z",
  fill: "#cdebfc"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 309",
  d: "M367.002 511h-176V343h105.7a74.76 74.76 0 0174.63 67.54l10.6 83.979A15.008 15.008 0 01367.002 511z",
  fill: "#bfe1fd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 311",
  d: "M295.002 215h-32v-64h32a32 32 0 010 64z",
  fill: "#e2dff4"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 312",
  d: "M119.002 215h-32a32 32 0 010-64h32z",
  fill: "#f9f9f9"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 313",
  d: "M239.002 343l-36 48a15 15 0 01-24 0l-36-48 9.6-64h76.8z",
  fill: "#af7a4a"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 314",
  d: "M239.002 343l-36 48a14.911 14.911 0 01-12 6V279h38.4z",
  fill: "#9d7045"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 315",
  d: "M278.002 137.39V215l-5.34 29.97v.03a87.123 87.123 0 01-82.21 57c-48.02-.3-86.45-40.13-86.45-88.15v-76.46a45.335 45.335 0 0135.76-44.04c13.79-2.949 35.29-9.92 51.24-26.22 15.95 16.3 37.45 23.271 51.24 26.22a45.335 45.335 0 0135.76 44.04z",
  fill: "#d5985c"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 316",
  d: "M278.002 215l-5.34 30h.01a87.159 87.159 0 01-81.67 57V67.13c15.95 16.3 37.45 23.271 51.24 26.22a45.335 45.335 0 0135.76 44.04z",
  fill: "#af7a4a"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 317",
  d: "M278.002 215a86.32 86.32 0 01-5.34 30h-41.66a15 15 0 010-30z",
  fill: "#08475e"
})));
export default SvgOperator;